import FileExcelOutlined from '@ant-design/icons/FileExcelOutlined'
import FileImageOutlined from '@ant-design/icons/FileImageOutlined'
import FileOutlined from '@ant-design/icons/FileOutlined'
import FilePdfOutlined from '@ant-design/icons/FilePdfOutlined'
import FileWordOutlined from '@ant-design/icons/FileWordOutlined'

export default function FileTypeIcon({ type, style, ...props }) {
  switch (type) {
    case 'pdf':
      return <FilePdfOutlined style={{ color: '#FF3E4C', ...style }} {...props} />
    case 'excel':
      return <FileExcelOutlined style={{ color: '#217346', ...style }} {...props} />
    case 'word':
      return <FileWordOutlined style={{ color: '#2B579A', ...style }} {...props} />
    case 'image':
      return <FileImageOutlined style={{ color: '#A779F3', ...style }} {...props} />
    default:
      return <FileOutlined style={{ color: '#707070', ...style }} {...props} />
  }
}
